export enum firebaseProvider {
  Google = 'google.com',
  Microsoft = 'microsoft.com',
  ClassLink = 'oidc.classlink',
  LtiCanvas = 'lti.canvas',
  Clever = 'clever'
}
